import Vue from 'vue'
import App from './App.vue'
import {router} from './router'
import store from './store'
import Api from './plugins/Api'
import BootstrapVue from 'bootstrap-vue'
import VueLazyLoad from 'vue-lazyload'

/* Fa5 Pro Support */
import {library} from '@fortawesome/fontawesome-svg-core'
// import {fal} from '@fortawesome/pro-light-svg-icons'
import {faHome, faEnvelope, faUsers, faTags, faMapSigns, faBuilding, faPlayCircle, faImages} from '@fortawesome/pro-light-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import icon from './components/Icon'

library.add(faHome, faEnvelope, faUsers, faTags, faMapSigns, faBuilding, faPlayCircle, faImages);

Vue.config.productionTip = false;

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('icon', icon);

Vue.use(BootstrapVue, Api);

Vue.use(require('vue-moment'));

Vue.prototype.$Api = Api;

Vue.use(VueLazyLoad);

require('vue-image-lightbox/dist/vue-image-lightbox.min.css');

import Sidebar from './components/Sidebar'

Vue.component('Sidebar', Sidebar);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');